import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardType } from '../../../core/enum/card-type.enum';


@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss'
})
export class CardComponent {
  @Input() title: string = 'Card Title';
  @Input() buttonLabel: string = 'Click Me';
  @Input() isApp: boolean = false;

  @Input() download: boolean = false;
  @Input() direction: boolean = false;

  @Input() cardType!: CardType;
  @Output() action = new EventEmitter<CardType>();

  onButtonClick(): void {
    this.action.emit(this.cardType);
  }
}
